import {getHttpClient} from "../apiClient";

export const loadSites = ()=>{
    return (dispatch, getState)=>{
        return getHttpClient().get('/sites',{
            params:{
                fields:'id, name, logo, affiliate_portal',
                limit:10,
                offset: 0
            }
        }).then(({data}) => {
            if(data.sites) {
                dispatch({
                    type: 'set-sites',
                    sites: data.sites
                })
            }
        }).catch((e)=>e)
    }
}
